import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { DarkMode, LightMode } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useUIContext } from "@/context/UIContext";

function ThemeToggle() {
  const { t } = useTranslation();
  const { colorMode, toggleColorMode } = useUIContext();

  return (
    <Tooltip title={colorMode === "light" ? t("common.themeDark") : t("common.themeLight")}>
      <IconButton
        onClick={toggleColorMode}
        color="inherit"
        aria-label={t("common.themeToggle")}
        data-testid="button-theme-toggle"
        size="small"
      >
        {colorMode === "light" ? <DarkMode /> : <LightMode />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;
